import { Controller } from "@hotwired/stimulus";

// The inline rename control on the "gift template flow in progress" banner
// (gives/_gift_template_banner.html.haml). The save button submits its own `remote: true` form
// natively; this controller only owns the optimistic DOM update, not the request.
export default class extends Controller {
  static get targets() {
    return ["nameContainer", "name", "input", "toggleButton"];
  }

  activateEditor() {
    this.toggleButtonTarget.classList.toggle("hidden");
    this.nameContainerTarget.classList.toggle("editing");

    if (this.nameContainerTarget.classList.contains("editing")) {
      this.inputTarget.focus();
    }
  }

  saveGiftTemplate() {
    this.nameTarget.textContent = this.inputTarget.value;
    this.toggleButtonTarget.classList.toggle("hidden");
    this.nameContainerTarget.classList.toggle("editing");
  }
}
